import React from 'react';
// import Navigation from "../components/header/navigaton";
import Navigation from "../components/macro/header/navigaton";

// TODO: remove the previous use reference
// import Footer from "../components/footer/footer";
import Footer from "../components/macro/footer/footer";
// import SkinOverallHealth from "../components/common/skinReports/skinHealth";
import SkinOverallHealth from "../components/macro/skinReports/skinHealth";
// import CausewithRightImage from "../components/common/causeWithRightImage";
import CausewithRightImage from "../components/micro/causeWithRightImage/causeWithRightImage";
// import BlurAreaWithReduce from "../components/common/howToReduceBlurArea";
import BlurAreaWithReduce from "../components/micro/howToReduceBlurArea/howToReduceBlurArea";

const AcneReport = () => {
    return (
        <div>
            <Navigation/>
            {/* <SkinOverallHealth/> */}
            <CausewithRightImage />
            <BlurAreaWithReduce />
            {/*<Footer/>*/}
        </div>
    );
};

export default AcneReport;
